module.exports = __webpack_public_path__ + "42cfb4ede65b4d087aed2f994d569125.pdf";